import { useConfigSlice } from '../slices/config/selectors';

export const useSessionBalanceConfig = (): boolean => {
  const isSessionBalanceEnabled = useConfigSlice.casinoConfig()?.isSessionBalanceEnabled;
  const compliance = useConfigSlice.compliance();
  const sessionBalance = compliance?.sessionBalance;

  return !!(sessionBalance && isSessionBalanceEnabled);
};
